import { useLang } from "../../i18n/LangContext";
import { CheckCircle2, Lock } from "lucide-react";
import { L, formatDateID } from "./lib";

const STATE_STYLES = {
  COMPLETED: "border-emerald-500/30 bg-emerald-500/[0.06]",
  AVAILABLE: "border-[#FF3B30]/40 bg-[#FF3B30]/[0.05]",
  LOCKED: "border-white/5 bg-white/[0.02] opacity-60",
};

function LockNote({ day }) {
  const { t, lang } = useLang();
  if (day.state !== "LOCKED") {
    return day.available_date ? <div className="text-[11px] text-slate-600 mt-0.5">{formatDateID(day.available_date, lang)}</div> : null;
  }
  if (day.lock_reason === "FUTURE_DATE" && day.available_date) {
    return (
      <div data-testid={`journey-day-lock-reason-${day.day_number}`} className="text-[11px] text-slate-500 mt-0.5">
        {t("edu.availableOn").replace("{date}", formatDateID(day.available_date, lang))}
      </div>
    );
  }
  if (day.lock_reason === "PROGRESSION") {
    return (
      <div data-testid={`journey-day-lock-reason-${day.day_number}`} className="text-[11px] text-amber-400/80 mt-0.5">
        {t("edu.finishPreviousDay").replace("{day}", day.requires_day)}
      </div>
    );
  }
  return null;
}

export function DayList({ days, onOpen }) {
  const { t, lang } = useLang();
  if (days.length === 0) return <p data-testid="journey-empty" className="text-sm text-slate-500">{t("edu.noDays")}</p>;
  return (
    <div className="space-y-2">
      {days.map((d) => (
        <button
          key={d.day_id}
          data-testid={`journey-day-${d.day_number}`}
          disabled={d.state === "LOCKED"}
          onClick={() => onOpen(d.day_number)}
          className={`w-full text-left rounded-xl border p-4 transition flex items-center gap-4 ${STATE_STYLES[d.state]} ${d.state !== "LOCKED" ? "hover:border-white/20" : "cursor-not-allowed"}`}
        >
          <span className="h-11 w-11 shrink-0 rounded-xl bg-black/30 flex items-center justify-center font-[Outfit] font-extrabold text-sm text-white">
            {d.state === "COMPLETED" ? <CheckCircle2 className="h-5 w-5 text-emerald-400" /> : d.state === "LOCKED" ? <Lock className="h-4 w-4 text-slate-500" /> : d.day_number}
          </span>
          <div className="min-w-0 flex-1">
            <div className="text-[11px] uppercase tracking-widest text-slate-500">{t("edu.day")} {d.day_number}</div>
            <div className="font-semibold text-white truncate">{L(d.title, lang)}</div>
            <LockNote day={d} />
          </div>
          <span data-testid={`journey-day-state-${d.day_number}`} className={`text-[10px] font-bold uppercase tracking-wider shrink-0 ${d.state === "COMPLETED" ? "text-emerald-300" : d.state === "AVAILABLE" ? "text-[#FF3B30]" : "text-slate-500"}`}>
            {t(`edu.state_${d.state}`)}
          </span>
        </button>
      ))}
    </div>
  );
}
